<template>
  <div id="index">
    <div class="banner">
      <el-carousel height="420px">
        <el-carousel-item v-for="(items, index) in banners" :key="index">
          <img :src="items.ImageArrays" :title="items.Title" @click="JumpUrlFunc(index)" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay
  } from "swiper";
  // install Swiper modules
  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
  export default {
    name: "banner",
    props: ["pageTypeId"],
    data() {
      return {
        banners: [],
        swiperOption: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          // loop: true,
          pagination: {
            el: ".swiper-pagination1",
            clickable: true
          }
        }
      };
    },
    mounted: function() {
      //自动触发写入的函数
      let that = this;
      // // console.log(this.pageTypeId)
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=" +
          this.pageTypeId
        )
        .then(function(response) {
          // console.log("response",response)
          that.banners = response.data.results;
        })
        .catch(function() {
          // console.log('错误');
        });
    },
    methods: {
      //banner图链接判断（枚举ContentType的Id）
      JumpUrlFunc(index) {
        let that = this;
        const JumpUrlContentType = that.banners[index].ContentType;
        switch (JumpUrlContentType) {
          case 48:
            that.$router.push({
              path: "/course_details",
              query: {
                Id: that.banners[index].JumpUrl
              }
            });
            break;
          case 183:
            that.$router.push({
              path: "/publicClass_details",
              query: {
                Id: that.banners[index].JumpUrl,
                nav: 3
              }
            });

            break;
          case 49:
            that.$router.push({
              path: "/selfStudy_details",
              query: {
                Id: that.banners[index].JumpUrl,
                nav: 2
              }
            });
            break;
          case 50:
            window.open(that.banners[index].JumpUrl, "_blank");
            break;
          case 184:
            that.$router.push({
              path: "/languageTest",
              query: {
                Id: that.banners[index].JumpUrl,
                nav: 5
              }
            });
            break;
        }
      }
    }
  };
</script>

<style scoped>
  .bottombox {
    box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
    position: relative;
    z-index: 9;
  }

  .banner {
    width: 100%;
    height: 420px;
    position: relative;
  }

  .banner .el-carousel__item {
    display: flex;
    overflow: hidden;
    justify-content: center;
  }

  .banner img {
    max-width: 1920px;
    height: 420px;
    margin: 0 auto;
  }

  /*
/deep/ .el-carousel__arrow {
  background-color: rgba(168, 168, 168, 0.2);
  font-size: 24px;
  font-weight: 600;
}

/deep/ .el-carousel__arrow i {
  font-weight: bold;
}

/deep/ .el-carousel__arrow--left {
  left: 50%;
  margin-left: -610px;
}

/deep/ .el-carousel__arrow--right {
  right: 50%;
  margin-right: -610px;
} */

  /deep/ .swiper-pagination {
    width: 100%;
  }

  /deep/ .swiper-pagination .swiper-pagination-bullet {
    width: 34px;
    height: 8px;
    border: 1px #979797 solid;
    border-radius: 5px;
    background: #ffffff;
    margin: 0 17px;
  }

  /deep/ .swiper-pagination .swiper-pagination-bullet-active {
    width: 34px;
    height: 8px;
    border: 1px #979797 solid;
    border-radius: 5px;
    background: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/page2/banner/banner.vue